import { Routes } from '@angular/router';
import { RedirectAuthenticatedGuard } from '@core/guard/redirect-authenticated.guard';
import { LoginAuthComponent } from './children/auth/auth.component';
import { LoginRecoverPasswordComponent } from './children/recover-password/recover-password.component';
import { LoginRedirectComponent } from './children/redirect/redirect.component';
import { LoginResetPasswordComponent } from './children/reset-password/reset-password.component';
import { LoginComponent } from './login.component';
import { LoginResolver } from './services/login.resolver';
var ɵ0 = { title: 'CORE.SERVICES.NAVIGATION.TITLES.LOGIN' }, ɵ1 = { title: 'CORE.SERVICES.NAVIGATION.TITLES.AUTH_REDIRECT' }, ɵ2 = { title: 'CORE.SERVICES.NAVIGATION.TITLES.FORGOT_PASSWORD' }, ɵ3 = { title: 'CORE.SERVICES.NAVIGATION.TITLES.RESET_PASSWORD' };
var routes = [
    {
        path: 'entrar',
        redirectTo: 'login'
    },
    {
        path: 'esqueci-minha-senha',
        redirectTo: 'login/recuperar-senha'
    },
    {
        path: 'redirecionamento-usuario',
        redirectTo: 'login/redirecionando'
    },
    {
        path: 'login',
        component: LoginComponent,
        canActivate: [RedirectAuthenticatedGuard],
        resolve: { loginCustomization: LoginResolver },
        children: [
            {
                path: '',
                component: LoginAuthComponent,
                data: ɵ0,
            },
            {
                path: 'redirecionando',
                component: LoginRedirectComponent,
                data: ɵ1
            },
            {
                path: 'recuperar-senha',
                component: LoginRecoverPasswordComponent,
                data: ɵ2,
            },
            {
                path: 'recuperar-senha/:email',
                component: LoginResetPasswordComponent,
                data: ɵ3,
            }
        ]
    },
];
var LoginModule = /** @class */ (function () {
    function LoginModule() {
    }
    return LoginModule;
}());
export { LoginModule };
export { ɵ0, ɵ1, ɵ2, ɵ3 };
